import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot} from '@angular/router';
import {IpopConfigurationComponent} from './components/views/settings/ipop/ipop-configuration.component';

const ipopConfigurationRoutePath = 'settings/ipop/:accountId';
const dirtyRuleNavigationConfirmationMessage = 'Offer Set Rules are being processed for this account. Changes may not be visible immediately while processing is in progress.';

@Injectable({
  providedIn: 'root'
})
export class IpopDirtyNavigationGuard implements CanDeactivate<IpopConfigurationComponent> {
  /**
   * Confirms in-app navigation away from dirty rule changes.
   */
  canDeactivate(
    component: IpopConfigurationComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean {
    let canDeactivate = true;

    if (component.hasDirtyRuleConfiguration() && !this.isSamePageNavigation(currentRoute, currentState, nextState)) {
      component.queueDirtyRuleProcessingForNavigationAttempt();
      canDeactivate = window.confirm(dirtyRuleNavigationConfirmationMessage);
    }

    return canDeactivate;
  }

  /**
   * Checks whether routing stays on the same IPOP configuration page.
   */
  private isSamePageNavigation(
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean {
    let isSamePageNavigation = false;
    const isIpopRoute = currentRoute.routeConfig?.path === ipopConfigurationRoutePath;

    if (isIpopRoute && nextState) {
      const currentUrlParts = currentState.url.split('?');
      const nextUrlParts = nextState.url.split('?');
      const currentPath = currentUrlParts[0] ?? '';
      const nextPath = nextUrlParts[0] ?? '';

      if (currentPath === nextPath) {
        isSamePageNavigation = true;
      }
    }

    return isSamePageNavigation;
  }
}
